// Bare client bundle version the merchant app sends on RPC requests (e.g.
// "1.256634", or "_" in local dev). Read server-side lowercased.
export const CLIENT_VERSION_HEADER = "X-Redo-Client-Version";

// Epoch ms when the client bundle loaded (page load). Read server-side
// lowercased.
export const CLIENT_LOADED_AT_HEADER = "X-Redo-Client-Loaded-At";
